import { CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { FeatherModule } from 'angular-feather';
import { Activity, AlertOctagon, ArrowLeft, ArrowLeftCircle, ArrowRight, ArrowRightCircle, Bell, Disc, Edit, FileText, Github, Grid, Heart, HelpCircle, Home, Info, Key, Link, List, LogIn, LogOut, Mail, PenTool, PlusSquare, Settings, Shield, ShoppingBag, Smartphone, Star, Tag, Target, Trash, Trash2, User, X } from 'angular-feather/icons';
import { TestsSettingsComponent } from 'src/app/tests/tests-settings/tests-settings.component';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AddClientComponent } from './collection/add-client/add-client.component';
import { AddCollectionComponent } from './collection/add-collection/add-collection.component';
import { CollectionLandingComponent } from './collection/collection-landing/collection-landing.component';
import { EditCollectionComponent } from './collection/edit-collection/edit-collection.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ConfirmationDialogComponent } from './delivery/quiz/confirmation-dialog/confirmation-dialog.component';
import { HeaderComponent } from './header/header.component';
import { ChooseQuestionTypeComponent } from './items/choose-question-type/choose-question-type.component';
import { CreateNewItemComponent } from './items/create-new-item/create-new-item.component';
import { ItemBasicDetailsComponent } from './items/item-basic-details/item-basic-details.component';
import { AbcComponent } from './items/item-details/abc.component';
import { ItemDetailsComponent } from './items/item-details/item-details.component';
import { ItemLandingComponent } from './items/item-landing/item-landing.component';
import { ItemSettingsComponent } from './items/item-settings/item-settings.component';
import { ItemTagsComponent } from './items/item-tags/item-tags.component';
import { TanayMatarialModule } from './material.module';

import { TestsActivitiesComponent } from './tests/tests-activities/tests-activities.component';
import { TestsBasicDetailsComponent } from './tests/tests-basic-details/tests-basic-details.component';
import { TestsCreateComponent } from './tests/tests-create/tests-create.component';
import { TestsDetailsComponent } from './tests/tests-details/tests-details.component';
import { TestsExistingItemsComponent } from './tests/tests-existing-items/tests-existing-items.component';
import { TestsItemsComponent } from './tests/tests-items/tests-items.component';
import { TestsLandingComponent } from './tests/tests-landing/tests-landing.component';
import { TestsScheduleComponent } from './tests/tests-schedule/tests-schedule.component';
import { TestsTagsComponent } from './tests/tests-tags/tests-tags.component';
import { UserModule } from './user/user.module';
import { UserheaderComponent } from './userheader/userheader.component';
import { UserCreateComponent } from './users/user-create/user-create.component';
import { UserEditComponent } from './users/user-edit/user-edit.component';
import { UserLandingComponent } from './users/user-landing/user-landing.component';

import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
// import { CKEditorModule } from 'ckeditor4-angular';
import { CKEditorModule } from "@ckeditor/ckeditor5-angular";
import { MatSelectFilterModule } from 'mat-select-filter';
import { NgDialogAnimationService } from 'ng-dialog-animation';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { CountdownModule } from 'ngx-countdown';
import { NgxEditorModule } from 'ngx-editor';
import { NgxPrintElementModule } from 'ngx-print-element';
import { AddUSerDialog } from 'src/app/collection/collection-users/add-user-dialog';
import { AddCollectionUsersComponent } from './collection/add-collection-users/add-collection-users.component';
import { CollectionDetailsComponent } from './collection/collection-details/collection-details.component';
import { CollectionUsersComponent } from './collection/collection-users/collection-users.component';
import { CollectionhomeComponent } from './collection/collectionhome/collectionhome.component';
import { ExamineeloginComponent } from './examineelogin/examineelogin.component';
import { ExamineesGroupComponent } from './examinees-group/examinees-group.component';
import { ExaminessComponent } from './examiness/examiness.component';
import { ChangePasswordComponent } from './header/change-password/change-password.component';
import { AssignPrivilegesComponent } from './header/roles/assign-privileges/assign-privileges.component';
import { RolesComponent } from './header/roles/roles.component';
import AddMultipleItemComponent from './items/item-landing/add-multiple-item/add-multiple-item.component';
import { QuestionListComponent } from './items/question-list/question-list.component';
import { LoaderComponent } from './loader/loader.component';
import { LoaderInterceptor } from './loader/loader.interceptor';
import { NotepadComponent } from './notepad/notepad.component';

import { ResizeColumnDirective } from './resize-column.directive';
import { GlobalInterceptor } from './services/global.interceptor';
import { ConfimationMessageComponent } from './shared/confimation-message/confimation-message.component';
import { DelMessageComponent } from './shared/del-message/del-message.component';
import { TestRedirectionComponent } from './test-redirection/test-redirection.component';
import { AddReciepantsComponent } from './tests/add-reciepants/add-reciepants.component';
import { AddTestsNewScheduleComponent } from './tests/add-tests-new-schedule/add-tests-new-schedule.component';
import { AddTestsScheduleComponent } from './tests/add-tests-schedule/add-tests-schedule.component';
import { EditTestsScheduleComponent } from './tests/edit-tests-schedule/edit-tests-schedule.component';
import { AddRecipientDialogboxComponent } from './tests/schedules/add-recipient-dialogbox/add-recipient-dialogbox.component';
import { NewSchedulePopupComponent } from './tests/tests-schedule/new-schedule-popup/new-schedule-popup.component';
import { ResetPasswordComponent } from './user/reset-password/reset-password.component';

import { ItemPreviewComponent } from '@items/item-preview/item-preview.component';
import { PreviewDescriptivePlainTextComponent } from '@items/preview/preview-descriptive-plain-text/preview-descriptive-plain-text.component';
import { PreviewFillInTheBlankTextComponent } from '@items/preview/preview-fill-in-the-blank-text/preview-fill-in-the-blank-text.component';
import { PreviewMatchOrderMatchListComponent } from '@items/preview/preview-match-order-match-list/preview-match-order-match-list.component';
import { PreviewMatrixSingleChoiceComponent } from '@items/preview/preview-matrix-single-choice/preview-matrix-single-choice.component';
import { PreviewMultipleChoiceMultipleResponseComponent } from '@items/preview/preview-multiple-choice-multiple-response/preview-multiple-choice-multiple-response.component';
import { PreviewMultipleChoiceSingleResponseComponent } from '@items/preview/preview-multiple-choice-single-response/preview-multiple-choice-single-response.component';
import { PreviewMultipleChoiceTrueOrFalseComponent } from '@items/preview/preview-multiple-choice-true-or-false/preview-multiple-choice-true-or-false.component';
import { PreviewOptionEditorComponent } from '@items/preview/preview-option-editor/preview-option-editor.component';
import { PreviewSurveyLikeDislikeComponent } from '@items/preview/preview-survey-like-dislike/preview-survey-like-dislike.component';
import { PreviewSurveyMultiResponseComponent } from '@items/preview/preview-survey-multi-response/preview-survey-multi-response.component';
import { PreviewSurveyNumberRatingComponent } from '@items/preview/preview-survey-number-rating/preview-survey-number-rating.component';
import { PreviewSurveyShortAnswerComponent } from '@items/preview/preview-survey-short-answer/preview-survey-short-answer.component';
import { PreviewSurveySingleChoiceComponent } from '@items/preview/preview-survey-single-choice/preview-survey-single-choice.component';
import { PreviewSurveyStarRatingComponent } from '@items/preview/preview-survey-star-rating/preview-survey-star-rating.component';
import { ItemsDescriptivePlainTextComponent } from '@items/question/items-descriptive-plain-text/items-descriptive-plain-text.component';
import { ItemsFillInTheBlankTextComponent } from '@items/question/items-fill-in-the-blank-text/items-fill-in-the-blank-text.component';
import { ItemsMatchOrderMatchListComponent } from '@items/question/items-match-order-match-list/items-match-order-match-list.component';
import { ItemsMatrixSingleChoiceComponent } from '@items/question/items-matrix-single-choice/items-matrix-single-choice.component';
import { ItemsMultipleChoiceMultipleResponseComponent } from '@items/question/items-multiple-choice-multiple-response/items-multiple-choice-multiple-response.component';
import { ItemsMultipleChoiceSingleResponseComponent } from '@items/question/items-multiple-choice-single-response/items-multiple-choice-single-response.component';
import { ItemsMultipleChoiceTrueOrFalseComponent } from '@items/question/items-multiple-choice-true-or-false/items-multiple-choice-true-or-false.component';
import { ItemsSubPartEditorComponent } from '@items/question/items-sub-part-editor/items-sub-part-editor.component';
import { ItemsSurveyLikeDislikeComponent } from '@items/question/items-survey-like-dislike/items-survey-like-dislike.component';
import { ItemsSurveyMultiResponseComponent } from '@items/question/items-survey-multi-response/items-survey-multi-response.component';
import { ItemsSurveyNumberRatingComponent } from '@items/question/items-survey-number-rating/items-survey-number-rating.component';
import { ItemsSurveyShortAnswerComponent } from '@items/question/items-survey-short-answer/items-survey-short-answer.component';
import { ItemsSurveySingleChoiceComponent } from '@items/question/items-survey-single-choice/items-survey-single-choice.component';
import { ItemsSurveyStarRatingComponent } from '@items/question/items-survey-star-rating/items-survey-star-rating.component';

import { AddStrategyComponent } from '@items/ai-questions/add-Strategy/add-Strategy.component';
import { AiGeneratedQuestionsComponent } from '@items/ai-questions/ai-generated-questions/ai-generated-questions.component';
import { QuestionListDetailsComponent } from '@items/question-list-details/question-list-details.component';
import { ArraytonewlinePipe } from '@pipes/arraytonewline.pipe';
import { BoldTagPipe } from '@pipes/bold-tag.pipe';
import { DateAgoPipe } from '@pipes/date-ago.pipe';
import { ItemsfilterPipe } from '@pipes/itemsfilter.pipe';
import { LanguagePipe } from '@pipes/language.pipe';
import { Nl2brPipe } from '@pipes/nl2br.pipe';
import { OrderByPipe } from '@pipes/orderBy.pipe';
import { RoleManagementService } from '@services/role.management.service';
import { TestPreviewComponent } from './tests/test-preview/test-preview.component';
import { SubscriptionComponent } from './header/subscription/subscription.component';
import { CreditsUsageComponent } from './header/subscription/credits-usage/credits-usage.component';
import { PurchaseHistoryComponent } from './header/subscription/purchase-history/purchase-history.component';
import { ItemGroupListComponent } from './tests/item-group-list/item-group-list.component';
import { CreateItemGroupComponent } from './tests/create-item-group/create-item-group.component';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { GlobalErrorHandlerService } from '@services/global-error-handler-service.service';
import { CollectionStyleGroupsComponent } from './collection/collection-style-group/collection-style-groups/collection-style-groups.component';
import { CreateNewStyleGroupComponent } from './collection/collection-style-group/create-new-style-group/create-new-style-group.component';
import { StyleGroupDetailsComponent } from './collection/collection-style-group/style-group-details/style-group-details.component';
import { CreateNewStyleComponent } from './collection/collection-style-group/create-new-style/create-new-style.component';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { SanitizeHtmlPipe } from '@pipes/sanitize-html.pipe';
import { FilterValidatorDirective } from './filter-validator.directive';
// import { TextBoxPlugin } from '../app/textbox.plugin';
import { TextBoxPlugin } from './textbox.plugin';
import { CKEditorPlugins } from '@ckeditor/ckeditor5-build-classic';
import { UserUnblockedComponent } from './header/change-password/user-unblocked/user-unblocked.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { ChangePasswordSComponent } from './user/change-password/change-password.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { OnlyNumberDirective } from './two-digit-decima-number-directive.directive';
import { UserNotifyComponent } from './shared/user-notify/user-notify.component';
import { NgxPanZoomModule } from 'ngx-panzoom';
import { ItemsHotspotQuestionComponent } from '@items/question/items-hotspot-question/items-hotspot-question.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { PreviewHotspotQuestionComponent } from '@items/preview/preview-hotspot-question/preview-hotspot-question.component';
import { PreviewHotspotMultiChoiceComponent } from '@items/preview/preview-hotspot-multi-choice/preview-hotspot-multi-choice.component';
import { ItemsHotspotMultiChoiceComponent } from '@items/question/items-hotspot-multi-choice/items-hotspot-multi-choice.component';
import { HomeComponent } from './home/home/home.component';
import { PatientLandingComponent } from './Assessment/patient-landing/patient-landing.component';
import { ConfirmOtpComponent } from './Assessment/confirm-otp/confirm-otp.component';
import { AssignAssessmentComponent } from './Assessment/assign-assessment/assign-assessment.component';
import { PatientAssessmentDetailsComponent } from './Assessment/patient-assessment-details/patient-assessment-details.component';
import { MinutesSecondsPipe } from './minutes-seconds.pipe';

const icons = {
  Home, Grid, List, FileText, Tag, Edit, LogIn, LogOut, Mail, X,
  Link, Info, Bell, User, Heart, Trash, Trash2, PenTool, Settings, HelpCircle, Github,
  ArrowLeftCircle, ArrowLeft, ArrowRightCircle, ArrowRight, AlertOctagon, Disc, PlusSquare,
  Star, Target, ShoppingBag, Shield, Smartphone, Activity, Key,
};

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http,'./assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    ItemsSubPartEditorComponent,
    ItemsMultipleChoiceMultipleResponseComponent,
    ItemsMatchOrderMatchListComponent,
    ItemsFillInTheBlankTextComponent,
    ItemsMultipleChoiceTrueOrFalseComponent,
    ItemsMultipleChoiceSingleResponseComponent,
    ItemsSurveySingleChoiceComponent,
    ItemsSurveyMultiResponseComponent,
    ItemsSurveyShortAnswerComponent,
    ItemsSurveyLikeDislikeComponent,
    ItemsSurveyStarRatingComponent,
    ItemsSurveyNumberRatingComponent,
    ItemsMatrixSingleChoiceComponent,
    ItemsDescriptivePlainTextComponent,
    ItemPreviewComponent,
    QuestionListDetailsComponent,
    AiGeneratedQuestionsComponent,
    TestPreviewComponent,

    DateAgoPipe,
    Nl2brPipe,
    ArraytonewlinePipe,
    ItemsfilterPipe,
    OrderByPipe,
    BoldTagPipe,
    LanguagePipe,
    SanitizeHtmlPipe,
    PreviewMultipleChoiceMultipleResponseComponent,
    PreviewSurveyStarRatingComponent,
    PreviewMultipleChoiceTrueOrFalseComponent,
    PreviewMultipleChoiceSingleResponseComponent,
    PreviewSurveySingleChoiceComponent,
    PreviewSurveyShortAnswerComponent,
    PreviewSurveyMultiResponseComponent,
    PreviewSurveyLikeDislikeComponent,
    PreviewSurveyNumberRatingComponent,
    PreviewMatrixSingleChoiceComponent,
    PreviewFillInTheBlankTextComponent,
    PreviewDescriptivePlainTextComponent,
    PreviewOptionEditorComponent,
    PreviewMatchOrderMatchListComponent,
    ItemLandingComponent,
    AddMultipleItemComponent,
    ItemDetailsComponent,
    HeaderComponent,
    AbcComponent,
    ItemTagsComponent,
    ChooseQuestionTypeComponent,
    ItemBasicDetailsComponent,
    ItemSettingsComponent,
    TestsLandingComponent,
    TestsDetailsComponent,
    TestsBasicDetailsComponent,
    TestsItemsComponent,
    TestsTagsComponent,
    TestsExistingItemsComponent,
    TestsScheduleComponent,
    TestsSettingsComponent,
    UserheaderComponent,
    TestsCreateComponent,
    CreateNewItemComponent,
    AddCollectionComponent,
    AddClientComponent,
    UserLandingComponent,
    UserCreateComponent,
    UserEditComponent,
    CollectionLandingComponent,
    EditCollectionComponent,
    DashboardComponent,
    TestsActivitiesComponent,
    ConfirmationDialogComponent,
    DelMessageComponent,
    CollectionhomeComponent,
    CollectionUsersComponent,
    CollectionDetailsComponent,
    AddCollectionUsersComponent,
    ExaminessComponent,
    AddUSerDialog,
    ExamineeloginComponent,
    AddTestsScheduleComponent,
    ChangePasswordComponent,
    ResetPasswordComponent,
    ConfimationMessageComponent,
    ExamineesGroupComponent,
    ResizeColumnDirective,
    QuestionListComponent,
    NewSchedulePopupComponent,
    AddTestsNewScheduleComponent,
    AddReciepantsComponent,
    EditTestsScheduleComponent,
    LoaderComponent,
    NotepadComponent,
    AddRecipientDialogboxComponent,
    TestRedirectionComponent,
    RolesComponent,
    AssignPrivilegesComponent,
    AddStrategyComponent,
    SubscriptionComponent,
    CreditsUsageComponent,
    PurchaseHistoryComponent,
    ItemGroupListComponent,
    CreateItemGroupComponent,
    CollectionStyleGroupsComponent,
    CreateNewStyleGroupComponent,
    StyleGroupDetailsComponent,
    CreateNewStyleComponent,
    FilterValidatorDirective,
    UserUnblockedComponent,
    ChangePasswordSComponent,
    OnlyNumberDirective,
    UserNotifyComponent,
    ItemsHotspotQuestionComponent,
    ItemsHotspotMultiChoiceComponent,
    PreviewHotspotQuestionComponent,
    PreviewHotspotMultiChoiceComponent,
    HomeComponent,
    PatientLandingComponent,
    ConfirmOtpComponent,
    AssignAssessmentComponent,
    PatientAssessmentDetailsComponent,
    MinutesSecondsPipe
  ],
  imports: [
    CommonModule,
    BrowserModule,
    UserModule,
    MatTooltipModule,
    MatButtonModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    TanayMatarialModule,
    FeatherModule.pick(icons),
    MatDialogModule,
    NgxEditorModule,
    MatSelectFilterModule,
    MatInputModule,
    MatTableModule,
    MatSelectModule,
    MatFormFieldModule,
    CountdownModule,
    CKEditorModule,
    NgxPrintElementModule,
    MatProgressBarModule,
    AngularEditorModule,
    NgMultiSelectDropDownModule.forRoot(),
    TranslateModule.forRoot({
      defaultLanguage: 'en-US',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
    }
    }),
    NgxPanZoomModule,
    ColorPickerModule,
  ],

  exports: [
    DateAgoPipe,
    ItemsDescriptivePlainTextComponent,
    ResizeColumnDirective,
    OrderByPipe,
    SanitizeHtmlPipe,
    FilterValidatorDirective,
    OnlyNumberDirective,

  ],

  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: GlobalInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: ErrorHandler, useClass:GlobalErrorHandlerService},
    {
      provide: MatDialogRef,
      useValue: {}
    },
    // {
    //   provide: CKEditorPlugins,
    //   useValue: [TextBoxPlugin],
    //   multi: true,
    // },
    NgDialogAnimationService,
    RoleManagementService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

